export default "__VITE_ASSET__86e43ea9__"